import { Column, Grid, Row } from "@1js/pl-card-components";
import * as React from "react";
import { SectionTitle } from "../SectionTitle/SectionTitle.web";
import type { Article } from "../data";
import { PromptArtList } from "./PromptArtList.web";

export const PromptArtSection: React.FC<{
  title: string;
  articles: Article[];
}> = ({ title, articles }) => {
  return (
    <Grid testid="prompt-art">
      <Row>
        <Column size={12}>
          <SectionTitle title={title} />
        </Column>
      </Row>
      <Row>
        <Column size={12}>
          <PromptArtList articles={articles} />
        </Column>
      </Row>
    </Grid>
  );
};
